module.exports = __webpack_public_path__ + "media/What_is_W_Work_Final.a237d53b.mp4";